import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Content = () => {
  const data = useStaticQuery(graphql`
    query {
      heroImage: file(relativePath: { eq: "marketing/schedule-meeting.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <div className="content-section bg-default-6 pt-lg-15 pt-10 pb-13 pb-lg-21">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col sm="10" lg="7">
              <div
                className="double-image-group-opacity rounded-10"
                style={{border: '8px solid #161C2D'}}
              >
                <Img
                  className="main-img w-100"
                  alt="Image 1"
                  fluid={data.heroImage.childImageSharp.fluid}
                />
              </div>
            </Col>
            <Col sm="10" lg="5">
              <div className="content-text pt-11 pt-lg-0 pl-xl-7">
                <h2 className="gr-text-4 mb-7">
                  Convert More Inbound Leads
                </h2>
                <p className="gr-text-8 mb-0">
                  Book meetings right from the video with a built-in calendar scheduling tool, while also optimizing for the 20% of all SaaS leads that come in over the weekend that normally receive no immediate engagement.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Content;
